import '../../../stylesheets/3d.scss'
import {STATUS_TYPES} from '../../render/constants'
import {defaultViewerConfig} from '../lib/config'
import ThreeDViewer from '../lib/viewer'

export function blobInitializer() {
  const config = defaultViewerConfig()

  return new ThreeDViewer('#solid-viewer', function (error: string | null, viewer: ThreeDViewer) {
    if (error) {
      viewer.status.set(STATUS_TYPES.error, {error})
      return
    }

    // Load the file advertised in the DOM, and bind handlers
    // for a ready status differently depending on if we
    // load a diff or a single file.
    try {
      const file = viewer.container.getAttribute('data-file') ?? ''
      viewer.load(file, {
        ...config,
        autoscale: true,
        scaleTo: 100,
      })
    } catch (e) {
      viewer.status.set(STATUS_TYPES.error, {error: (e as Error).message})
    }
  })
}
